/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplierResponseLineDto
 */
export interface SupplierResponseLineDto {
    /**
     * SupplierBatchLine ID
     * @type {number}
     * @memberof SupplierResponseLineDto
     */
    lineId: number;
    /**
     * Total qty supplier can fulfill across all linked orderItems. Required unless `unavailable` is true.
     * @type {number}
     * @memberof SupplierResponseLineDto
     */
    confirmedTotalQty?: number;
    /**
     * Supplier-confirmed unit price. Omit to keep the requested unit price.
     * @type {number}
     * @memberof SupplierResponseLineDto
     */
    confirmedUnitPrice?: number;
    /**
     * Set true when supplier cannot fulfill any qty for this line.
     * @type {boolean}
     * @memberof SupplierResponseLineDto
     */
    unavailable?: boolean;
    /**
     * Free-text notes from the supplier call
     * @type {string}
     * @memberof SupplierResponseLineDto
     */
    supplierNotes?: string;
}

/**
 * Check if a given object implements the SupplierResponseLineDto interface.
 */
export function instanceOfSupplierResponseLineDto(value: object): value is SupplierResponseLineDto {
    if (!('lineId' in value) || value['lineId'] === undefined) return false;
    return true;
}

export function SupplierResponseLineDtoFromJSON(json: any): SupplierResponseLineDto {
    return SupplierResponseLineDtoFromJSONTyped(json, false);
}

export function SupplierResponseLineDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierResponseLineDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lineId': json['lineId'],
        'confirmedTotalQty': json['confirmedTotalQty'] == null ? undefined : json['confirmedTotalQty'],
        'confirmedUnitPrice': json['confirmedUnitPrice'] == null ? undefined : json['confirmedUnitPrice'],
        'unavailable': json['unavailable'] == null ? undefined : json['unavailable'],
        'supplierNotes': json['supplierNotes'] == null ? undefined : json['supplierNotes'],
    };
}

export function SupplierResponseLineDtoToJSON(value?: SupplierResponseLineDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lineId': value['lineId'],
        'confirmedTotalQty': value['confirmedTotalQty'],
        'confirmedUnitPrice': value['confirmedUnitPrice'],
        'unavailable': value['unavailable'],
        'supplierNotes': value['supplierNotes'],
    };
}

